import { theme } from '@otsofintech/sofinx-ui/lib/style'
import { t as nox } from './style'

// NOX 品牌 theme：覆寫 SoFinX palette 關鍵色，保留 shadow / textLevel 原始結構
// 只在 LANDING_VERSION === 'nox' 時套用，其他版本不受影響
export const noxTheme = {
  ...theme,
  palette: {
    ...theme.palette,

    // ---- 主色系：teal → NOX 深色按鈕 ----
    // 對齊 landing CTA：slate-950 深底 + 白字（blue-600 保留給 accent／hover）
    primary: nox.slate950,       // #020617（CTA 按鈕底色）
    success2: nox.blue600,       // 保留藍色當 accent（tab 底線、focus ring 等）
    tertiary: nox.blue400,
    secondary: nox.slate700,

    // primary 漸層色階（SoFinX 原本是粉色階，換成 NOX 藍階）
    primary50: nox.blue50,
    primary200: nox.blue100,
    primary300: nox.blue200,
    primary400: nox.blue300,
    primary500: nox.blue400,
    primary600: nox.blue500,
    primary700: nox.blue600,

    // ---- 中性色：暖灰 → slate 冷灰 ----
    grey60: nox.slate950,        // 全站最深色文字/按鈕
    grey50: nox.slate700,
    grey40: nox.slate500,
    grey31: nox.slate500,
    grey30: nox.slate400,
    grey21: nox.slate900,
    grey20: nox.slate100,
    grey10: nox.slate50,
    grey100: nox.slate200,
    grey200: nox.slate400,
    greyBG: nox.bg,              // 全站非 landing 頁面底色（原 #F8F8F8 → #fcfdff）

    // ---- selection 色（primary @ 15% alpha）----
    extend1: 'rgba(37, 99, 235, 0.15)',
  },
}
